import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import usePortal from 'react-useportal';
import isEmpty from 'lodash/isEmpty';

import Table from './Table';
import {
  getTransfersOfferType,
  transferStatusConverter,
} from '../../../../../../service/utils';
import { POPUPS } from '../../../../../../service/constants';
import { showPopupWindow } from '../../../../../../redux/actions/Popups';
import { setDataForCardRequest } from '../../../../../../redux/actions/Transfers';
import { getPopupByName } from '../../../../../../redux/selector/Popups';
import { BuyOfferPopup, LoanPopup } from '../../../../../../components/Popup';

const { TRANSFER_SEARCH_POPUP, LOAN_OFFER_POPUP } = POPUPS;

const playerTeamName = (player, sendingTeam) =>
  player?.teamName ||
  player?.team?.name ||
  sendingTeam?.name ||
  '';

const DealsTable = ({ deals, teamId }) => {
  const dispatch = useDispatch();
  const [offerPlayer, setOfferPlayer] = useState(null);

  const transferSearchPopup = useSelector(getPopupByName(TRANSFER_SEARCH_POPUP));
  const loanPopupData = useSelector(getPopupByName(LOAN_OFFER_POPUP));

  const { Portal } = usePortal({
    bindTo: document && document.querySelector('#modal'),
  });

  const data = useMemo(
    () =>
      (Array.isArray(deals) ? deals : [])
        .filter((item) => item?.player && item?.sending_team?._id)
        .map((item) => ({
          date: item.createdAt,
          dealType: getTransfersOfferType(
            teamId,
            item.sending_team._id,
            item.category
          ),
          category: item.category,
          playerName: item.player.name,
          playerId: item.player._id,
          player: item.player,
          sendingTeam: item.sending_team,
          amount: item.transfer_fee_offer,
          status: transferStatusConverter[item.status] || item.status,
        })),
    [deals, teamId]
  );

  const columns = useMemo(
    () => [
      {
        Header: 'Date',
        accessor: 'date',
      },
      {
        Header: 'Deal type',
        accessor: 'dealType',
      },
      {
        Header: 'Player Name',
        accessor: 'playerName',
      },
      {
        Header: 'Amount',
        accessor: 'amount',
      },
      {
        Header: 'Status',
        accessor: 'status',
      },
      {
        Header: 'Action',
        id: 'action',
        disableSortBy: true,
      },
    ],
    []
  );

  const onMakeOffer = (row) => {
    setOfferPlayer({
      ...row.player,
      teamName: playerTeamName(row.player, row.sendingTeam),
    });
    if (row.dealType === 'Buy') {
      dispatch(showPopupWindow(row.playerId, TRANSFER_SEARCH_POPUP, false));
      return;
    }
    if (row.dealType === 'Loan In') {
      dispatch(
        setDataForCardRequest({
          id: row.playerId,
          name: row.playerName,
          transfer_fee_offer: null,
        })
      );
      dispatch(showPopupWindow(LOAN_OFFER_POPUP, LOAN_OFFER_POPUP, false));
    }
  };

  return (
    <>
      {!isEmpty(transferSearchPopup) && offerPlayer && (
        <Portal>
          <BuyOfferPopup
            playerId={offerPlayer._id}
            minPotentialValue={offerPlayer.potential_min}
            maxPotentialValue={offerPlayer.potential_max}
            popupName={TRANSFER_SEARCH_POPUP}
            team={offerPlayer.teamName}
            playerName={offerPlayer.name}
          />
        </Portal>
      )}
      {!isEmpty(loanPopupData) && offerPlayer && (
        <Portal>
          <LoanPopup
            popupName={LOAN_OFFER_POPUP}
            playerId={offerPlayer._id}
            playerName={offerPlayer.name}
            team={offerPlayer.teamName}
          />
        </Portal>
      )}
      <Table data={data} columns={columns} onMakeOffer={onMakeOffer} />
    </>
  );
};

export default DealsTable;
